import { $http } from '@/utils';
import { MD5 } from 'crypto-js';

/**
 * @namespace Service
 * @class Changelog
 * @exports Service/Cms/Changelog
 * @description API Changelog Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Changelog {
	/**
	 * @static @name list
	 * @description Get all changelog as a list that can be manipulated through post body properties
	 * @returns {Object} Promise a http response
	 */
	static list(payload) {
		return $http.post('cms/changelog/list', payload);
	}

	/**
	 * @static @name get
	 * @description Get changelog
	 * @param {String} id
	 * @returns {Object} Promise a http response
	 */
	static get(id) {
		return $http.get(`cms/changelog/${id}`);
	}

	/**
	 * @static @name list
	 * @description Get all changelog as a list that can be manipulated through post body properties
	 * @returns {Object} Promise a http response
	 */
	static getChangelogCategories(payload, domain, cache = true) {
		const cacheHash = MD5(JSON.stringify({ payload, domain })).toString();
		return $http.post(
			'cms/changelog-category/list',
			{ ...payload, cacheHash },
			{
				cache,
				cachePath: `table-cms-changelog-category-${cacheHash}`
			}
		);
	}

	/**
	 * @static @name addChangelogLike
	 * @description Add a changelog like to a specific changelog item
	 * @returns {Object} Promise a http response
	 */
	static addChangelogLike(payload) {
		return $http.post('cms/changelog-like', payload);
	}

	/**
	 * @static @name addChangelogComment
	 * @description Add a changelog like to a specific changelog item
	 * @returns {Object} Promise a http response
	 */
	static addChangelogComment(payload) {
		return $http.post('cms/changelog-comment', payload);
	}

	/**
	 * @static @name listLikeCounts
	 * @description Get like counts for given changelog items
	 * @returns {Object} Promise a http response
	 */
	static listLikeCounts(payload) {
		return $http.post('cms/changelog-like/list-counts', payload);
	}

	/**
	 * @static @name listCommentCounts
	 * @description Get comment counts for given changelog items
	 * @returns {Object} Promise a http response
	 */
	static listCommentCounts(payload) {
		return $http.post('cms/changelog-comment/list-counts', payload);
	}
}
